import { redirect } from "react-router-dom";

import { getProjectPath } from "@/modules/get-path";
import { generateProjectPromptMutation } from "@/services/lukita/mutations";
import { getAccount } from "../helpers";

export default async function generatePrompt({ request, params }) {
  const account = await getAccount();
  const { projectSlug } = params;

  const formData = await request.formData();
  const instructions = formData.get("instructions");

  await generateProjectPromptMutation(account?.id, projectSlug, instructions);
  return redirect(`${getProjectPath(projectSlug)}/ai-analysis`);
}
